import { parseBooleanValue } from "../../util";
import { ICaseDecision } from "../../caseDecisions/model/CaseDecision";

const CaseDecisionParamMapper = (item: ICaseDecision) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid),
    organisationId: item.organisationId,
    decisionDate:
      item.decisionDate instanceof Date
        ? item.decisionDate?.getTime()
        : item.decisionDate
  };
};

export default CaseDecisionParamMapper;
